import { createActions, createReducer } from "reduxsauce"

export const { Types, Creators } = createActions({
  setCategory: ["category"],
}, {
  prefix: "ompnt/modules/performance-top-factors",
})

const DEFAULT_STATE = {
  category: "",
}

function handleSetCategory(state, { category }) {
  return { ...state, category }
}

export default createReducer(DEFAULT_STATE, {
  [Types.SET_CATEGORY]: handleSetCategory,
})
